import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Typography,
  Menu,
  MenuItem,
  Backdrop,
  CircularProgress,
  Stack,
} from "@mui/material";
import MenuDrawer from "../../../components/MenuDrawer";
import AppBar from "../../../components/AppBar";
import { useLocation, useNavigate } from "react-router-dom";
import TitleWithSearchBar from "../../../components/TitleWithSearchBar";
import axios from "axios";
import { BASE_URL } from "../../../constants/config";
import { useSelector } from "react-redux";
import { CheckBox } from "@mui/icons-material";

const SingleForm = () => {
  const navigate = useNavigate();

  const location = useLocation();

  const { userRole } = useSelector((state) => state.user);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClose = () => {
    setAnchorEl(null);
  };

  const [loading, setloading] = useState(false);
  const [singleFormData, setsingleFormData] = useState([]);
  const [formName, setformName] = useState("");
  const [mainQuestion, setMainQuestion] = useState("");

  const [options, setOptions] = useState([]);

  const [search, setsearch] = useState("");

  const GetSingleForm = async () => {
    setloading(true);
    await axios
      .get(
        `${BASE_URL}/form/getFormDetailsForVendor?formId=${location?.state?.id}`,
        {
          withCredentials: true,
        }
      )
      .then(async (res) => {
        setloading(false);
        const data = res.data?.allForm?.map((i) => i.questions);
        setsingleFormData(data[0]);
        setMainQuestion(res.data?.allForm[0]?.documentTwo);
        setformName(res.data?.allForm[0]?.form_name);
        setOptions(res.data?.allForm[0]?.answers);
      })
      .catch((e) => {
        setloading(false);
      });
  };

  const GetSingleActivity = async () => {
    setloading(true);
    await axios
      .get(
        `${BASE_URL}/activity/getActivityDetails?activityId=${location?.state?.id}`,
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        setloading(false);
        // console.log("res", res.data?.activitySite?.activityName)
        setformName(res?.data?.activitySite?.activityName);
        setsingleFormData([res.data?.activitySite]);
        if (location?.state?.type === "Daily Activity") {
          setOptions(["Yes", "No"]);
        } else {
          setOptions(res?.data?.activitySite?.options);
        }
      })
      .catch((e) => {
        setloading(false);
      });
  };
  useEffect(() => {
    if (location?.state?.type === "Form") {
      GetSingleForm();
    } else {
      GetSingleActivity();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box style={{ backgroundColor: "#f7f8fa", display: "flex", flex: 1 }}>
      <MenuDrawer
        vendor={userRole === "vendor" ? true : false}
        admin={userRole === "admin" ? true : false}
        supervisor={userRole === "supervisor" ? true : false}
        provider={userRole === "doctor" ? true : false}
      />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          overflow: "hidden",
        }}
      >
        <AppBar title={location?.state?.type + " Details"} />
        <Grid container p={2}>
          <Grid item xs={12} md={12}>
            <Box
              mb={2}
              p={4}
              sx={{
                backgroundColor: "#fff",
                borderRadius: "12px",
              }}
            >
              {/* Title */}
              <TitleWithSearchBar
                title={formName}
                onClick={() => {
                  navigate("/vendor/forms/create", {
                    state: { role: "vendor" },
                  });
                }}
                noBtn={userRole === "vendor" ? true : true}
                search={search}
                noSearch={true}
                setSearch={setsearch}
              />
              <Box
                sx={{
                  // border: '1px solid #ccc',
                  // borderRadius: '8px',
                  padding: "16px",
                  maxWidth: "600px",

                  paddingBottom: "12px",
                }}
              >
                {/* <Typography variant="h6" component="h2" gutterBottom>
        {formName}
      </Typography> */}
                <Box sx={{ marginBottom: "12px" }}>
                  {/* <Typography variant="body1" sx={{ fontWeight: 'bold', marginBottom: '12px' }}>
          {formName}
        </Typography> */}
                  <Box>
                    {location?.state?.type === "Form" && (
                      <Typography variant="h6" component="h2" gutterBottom>
                        {mainQuestion}
                      </Typography>
                    )}

                    {location?.state?.type === "Form" &&
                      singleFormData?.map((option, index) => (
                        <>
                          <Typography
                            variant="body1"
                            sx={{ fontWeight: "bold", marginBottom: "12px" }}
                          >
                            {index + 1 + " :"} &nbsp;&nbsp; {option?.question}
                          </Typography>

                          {option?.answers?.map((answer, index) => (
                            <Stack
                              direction="row"
                              alignItems="center"
                              key={index}
                              sx={{ marginBottom: "12px" }}
                            >
                              <CheckBox color="primary" sx={{ fontSize: 28 }} />
                              <Stack direction="column" justifyContent="center">
                                <Typography
                                  sx={{
                                    fontSize: "14px",
                                    fontWeight: "400",
                                    color: "#596066",
                                    fontFamily: "FiraSans",
                                    ml: 1,
                                  }}
                                >
                                  Option: {answer}
                                </Typography>
                                <Typography
                                  sx={{
                                    fontSize: "14px",
                                    fontWeight: "400",
                                    color: "#596066",
                                    fontFamily: "FiraSans",
                                    ml: 1,
                                  }}
                                >
                                  Score: {option?.answerScores[index]}
                                </Typography>
                              </Stack>
                            </Stack>
                          ))}
                        </>
                      ))}
                    {location?.state?.type !== "Form" &&
                      options?.map((option, index) => (
                        <Stack
                          direction="row"
                          alignItems="center"
                          key={index}
                          sx={{ marginBottom: "8px" }}
                        >
                          <CheckBox color="primary" />
                          <Typography
                            sx={{
                              fontSize: "14px",
                              fontWeight: "400",
                              color: "#596066",
                              fontFamily: "FiraSans",
                              ml: 1,
                            }}
                          >
                            {option}
                          </Typography>
                        </Stack>
                      ))}
                  </Box>
                </Box>
              </Box>{" "}
              {/* Data Grid */}
              {/* <StyledDataGrid
                rows={
                  location?.state?.type==='Form' ?
                  singleFormData?.filter((val) =>
                    val?.question
                      ?.toLowerCase()
                      ?.includes(search?.toLocaleLowerCase())
                  ) :singleFormData || []
                }
                columns={formColumns}
                initialState={{
                  pagination: {
                    paginationModel: { page: 0, pageSize: 5 },
                  },
                }}
                sx={{
                  borderRadius: "12px",
                  border: "none",
                  "& .MuiDataGrid-virtualScroller": {
                    minHeight: "70vh",
                  },
                }}
                pageSizeOptions={[5, 10]}
                getRowClassName={(params) =>
                  params.row.id % 2 === 0 ? "even" : "odd"
                }
                rowSelectionModel={[]}
                rowSelection="none"
              />
 */}
              {/* Menu */}
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
              >
                <MenuItem
                  sx={{
                    borderBottom: "1px solid #EBEFF5",
                    color: "#24292E",
                    fontSize: "12px",
                    fontWeight: "400",
                    fontFamily: "FiraSans",
                  }}
                  onClick={() => {
                    handleClose();
                    navigate("/vendor/customers/create");
                  }}
                >
                  Edit
                </MenuItem>
                <MenuItem
                  sx={{
                    color: "#F34141",
                    fontSize: "12px",
                    fontWeight: "400",
                    fontFamily: "FiraSans",
                  }}
                  onClick={handleClose}
                >
                  Delete
                </MenuItem>
              </Menu>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default SingleForm;
